export class ProductVariantDetails {
    language: object;
    deliveryFormat: object;
    certificateType: object;
    productId: string;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-variants/details/product-variant-details.model.ts